import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'
import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ iValue, vNombreSocio, setIdSocio, setNombreSocio }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      // TODO values.condicionPago = data._idCondicionDePago || ''
      setIdSocio(pickedMember.value)

      setNombreSocio(data.numeroDocumento + ' - ' + data.razonSocial)
    })
  }

  const clickClear = () => {
    setIdSocio('')
    setNombreSocio('')
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {iValue ? (
            <ClearInputGroup id='input-codigoRucSocio' iValue={vNombreSocio} clickClear={clickClear} />
          ) : (
            <Select2Cliente id='codigoRucSelect' onChange={onChangeSocioHandler} />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
